
import { createClient } from '@supabase/supabase-js';

// Replace these values with your Supabase project URL and anon key
const supabaseUrl = 'https://cmbqeyfrirgowoyzjbbe.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNtYnFleWZyaXJnb3dveXpqYmJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY3NTQ3NjcsImV4cCI6MjA2MjMzMDc2N30.TmA-XQfNLFHoqHO4xUeGfNuFGhxeelP4M0um15gX43Y';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  const d = R * c; // Distance in km
  return d;
}

function deg2rad(deg: number): number {
  return deg * (Math.PI/180);
}
